<template>
  <div class="">
    <main>
      <section class="w-full min-h-screen bg-sidebar pt-17.5 pb-10">
        <img
          src="../assets/boogi-logo-gray-800.svg"
          class="h-9 mx-auto mb-15 block dark:hidden"
        />
        <img
          src="../assets/boogiwhitelogo.svg"
          class="h-9 mx-auto mb-15 hidden dark:block"
        />
        <div class="w-full">
          <div
            class="flex flex-col justify-center pb-10 sm:mx-auto sm:w-full sm:max-w-md px-4 sm:px-0 text-foreground"
          >
            <Card class="px-4 py-5 sm:p-5 rounded-2xl">
              <router-view />
            </Card>
            <footer class="w-full text-muted-foreground py-2 mt-4">
              <div
                class="max-w-7xl mx-auto px-4 flex flex-col sm:flex-row justify-between items-center"
              >
                <a class="text-sm mx-auto text-muted-foreground" href="https://boogi.io" target="_blank"
                  ><p>
                    &copy; {{ new Date().getFullYear() }} Boogi Technologies Ltd. All rights
                    reserved.
                  </p></a
                >
              </div>
            </footer>
          </div>
        </div>
      </section>
    </main>

    <!-- Footer -->
  </div>
</template>

<script>
import { Card } from '@boogi/ui'
export default {
  name: 'AuthView',
  components: { Card },
}
</script>
